import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconFormNames } from 'shared/assets/icons';
import { FormIcon } from 'shared/components/ui/form-icon';

import { useData } from '../../use-data';
import * as Styled from './meta-icon.style';

export type MetaIconProps = {
  value: IconFormNames;
  onChange: (icon: IconFormNames) => void;
};

export const MetaIcon: React.FC<MetaIconProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { createHabitIconAllowed, openPremiumDialog } = useData();

  return (
    <Styled.Container>
      <Styled.Label>{t('forms.habit.fields.icon.label')}</Styled.Label>
      <FormIcon
        onChange={onChange}
        value={value}
        isPremium={!createHabitIconAllowed}
        onPremium={openPremiumDialog}
      />
    </Styled.Container>
  );
};
